import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_note,
    CREATE_NOTE, 
    createNote,
    getAllNote,
    get_report,
    GET_REPORT,
    getItemNote
} from '../../../redux/note';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllSupervisor} from "../../../redux/supervisor";
import {getAllTurn} from "../../../redux/turn";
import Card from "../../../components/card";

const NotesAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_note = useSelector((state) => state.note_module._get_all_note);

    const _get_all_supervisor = useSelector((state) => state.supervisor_module._get_all_supervisor);
    const _get_all_turn = useSelector((state) => state.turn_module._get_all_turn);

    const _create_note = useSelector((state) => state.note_module._create_note);

    const _get_report = useSelector((store) => store.note_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllNote(token));
        // eslint-disable-next-line
    }, [token, dispatch]);


    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [supervisor, setSupervisor] = useState([]);
    const [turn, setTurn] = useState([]);
    const [establishment, setEstablishment] = useState([]);
    const [establishment_select, setEstablishmentSelect] = useState([]);

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + ' (' + element.codigo + ')'
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList])

    const handleChangeEstablishment = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento']: parseInt(e.value),
        });
        setEstablishmentSelect(e);
    }

    const [isLoading, setIsLoading] = useState(false);

    const onItemClickListener = async (item) => {
        const response = await getItemNote(token, item.id);
        console.log(response)
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_get_all_supervisor && _get_all_supervisor.data && _get_all_supervisor.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_supervisor.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                }
            })
            setSupervisor(array);
        }
    }, [_get_all_supervisor]);

    useEffect(() => {
        if (_get_all_turn && _get_all_turn.data && _get_all_turn.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_turn.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                }
            })
            setTurn(array);
        }
    }, [_get_all_turn]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Supervisor', id: 2},
        {name: 'Turno', id: 3},
        {name: 'Establecimiento', id: 4},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_turn: false,
        id_turn: 0,
        visible_supervisor: false,
        id_supervisor: 0,
        visible_establishment: false,
        id_establishment: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_establecimiento: 0,
        id_supervisor: 0,
        supervisor: "",
        id_turno: 0,
        turno: "",
        comentario: "",
        fecha_nota: "",
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_note.status === 201) {
            toast.success("Nota creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_note(CREATE_NOTE));
            dispatch(getAllNote(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_note.status !== 0) {
            toast.error(_create_note.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_note(CREATE_NOTE));
            setIsLoading(false);
        }
    }, [_create_note, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_note && _get_all_note.data && _get_all_note.data.datos) {
            setDatas(_get_all_note.data.datos);
        }

    }, [_get_all_note, count, props]);

    const loadFunc = () => {
        if (_get_all_note.data.datos) {
            if (_get_all_note.data.datos.length > count) {
                const ordenado = _get_all_note.data.datos.sort((a, b) => {
                    return new Date(b.fecha_nota + ' 00:00:00') - new Date(a.fecha_nota + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setSupervisorSelectFilter([]);
        setTurnSelectFilter([]);
        setEstablishmentSelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_note.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_turn: false,
                id_turn: 0,
                visible_supervisor: false,
                id_supervisor: 0,
                visible_establishment: false,
                id_establishment: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3' || e.target.value === '4') {
            if (e.target.value === '3') {
                dispatch(getAllTurn(token));
                setOtherFilter({
                    visible_turn: true,
                    id_turn: 0,
                    visible_supervisor: false,
                    id_supervisor: 0,
                    visible_establishment: false,
                    id_establishment: 0,
                });
            }
            if (e.target.value === '2') {
                dispatch(getAllSupervisor(token));
                setOtherFilter({
                    visible_turn: false,
                    id_turn: 0,
                    visible_supervisor: true,
                    id_supervisor: 0,
                    visible_establishment: false,
                    id_establishment: 0,
                });
            }
            if (e.target.value === '4') {
                setOtherFilter({
                    visible_turn: false,
                    id_turn: 0,
                    visible_supervisor: false,
                    id_supervisor: 0,
                    visible_establishment: true,
                    id_establishment: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_turn: false,
                id_turn: 0,
                visible_supervisor: false,
                id_supervisor: 0,
                visible_establishment: false,
                id_establishment: 0,
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_supervisor" || e.target.name === "id_turno" || e.target.name === "id_establecimiento") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const [supervisor_select, setSupervisorSelect] = useState([]);

    const handleChangeSupervisor = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_supervisor']: parseInt(e.value),
            // eslint-disable-next-line
            ['supervisor']: parseInt(e.label),
        });
        setSupervisorSelect(e);
    }

    const [turn_select, setTurnSelect] = useState([]);

    const handleChangeTurn = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_turno']: parseInt(e.value),
            // eslint-disable-next-line
            ['turno']: parseInt(e.label),
        });
        setTurnSelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento");
            setIsLoading(false);
            return;
        }
        if (form.id_supervisor === 0) {
            toast.error("Debe seleccionar el supervisor");
            setIsLoading(false);
            return;
        }
        if (form.id_turno === 0) {
            toast.error("Debe seleccionar el turno");
            setIsLoading(false);
            return;
        }
        if (form.fecha_nota === "") {
            toast.error("Debe seleccionar la fecha de la nota");
            setIsLoading(false);
            return;
        }
        if (form.comentario === "") {
            toast.error("Debe ingresar un comentario");
            setIsLoading(false);
            return;
        }
        dispatch(createNote(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_note.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_note.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_note.data.datos.filter(x => {
                    if (x.fecha_nota) {
                        let fecha = new Date(x.fecha_nota);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_note(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_note(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_turno': other_filter.id_supervisor,
            'id_supervisor': other_filter.id_turn,
            'id_establecimiento': other_filter.id_establishment,
        }, token));

    }

    const [supervisor_select_filter, setSupervisorSelectFilter] = useState([]);

    const handleChangeSupervisorFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_supervisor': parseInt(e.value),
        });
        let va = _get_all_note.data.datos.filter(x => parseInt(x.id_supervisor) === parseInt(e.value));
        setDatas(va);
        setSupervisorSelectFilter(e);
    }

    const [turn_select_filter, setTurnSelectFilter] = useState([]);

    const handleChangeTurnFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_turn': parseInt(e.value),
        });
        let va = _get_all_note.data.datos.filter(x => parseInt(x.id_turno) === parseInt(e.value));
        setDatas(va);
        setTurnSelectFilter(e);
    }

    const [establishment_select_filter, setEstablishmentSelectFilter] = useState([]);

    const handleChangeEstablishmentFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_establishment': parseInt(e.value),
        });
        let va = _get_all_note.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.value));
        setDatas(va);
        setEstablishmentSelectFilter(e);
    }


    const initSelect = {
        id: 0,
        secuencial: "",
        codigo_establecimiento: "",
        establecimiento: "",
        supervisor: "",
        turno: "",
        comentario: "",
        fecha_nota: "",
    };

    const [DataSelected, setDataSelected] = useState(initSelect);

    // const handleChangeFilter = (e) => {
    //     setOtherFilter({
    //         ...other_filter,
    //         [e.target.name]: parseInt(e.target.value),
    //     });
    //     if (e.target.value === "0") {
    //         setDatas(_get_all_note.data.datos);
    //     } else {
    //         if (e.target.name === 'id_establecimiento') {
    //             let va = _get_all_note.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.target.value));
    //             setDatas(va);
    //         }
    //         if (e.target.name === 'id_supervisor') {
    //             let va = _get_all_note.data.datos.filter(x => parseInt(x.id_supervisor) === parseInt(e.target.value));
    //             setDatas(va);
    //         }
    //         if (e.target.name === 'id_turno') {
    //             let va = _get_all_note.data.datos.filter(x => parseInt(x.id_turno) === parseInt(e.target.value));
    //             setDatas(va);
    //         }
    //     }
    // }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Notas"
                            items={[{label: "Listado de notas", link: "/notas"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="content-area-wrapper" style={{margin: 0}}>
                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_note").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        dispatch(getAllSupervisor(token));
                                                        dispatch(getAllTurn(token));
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                        setSupervisorSelect([]);
                                                        setTurnSelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-notea"
                                                    name="filtro-notea"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_supervisor && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Supervisor</label>
                                                                <Select
                                                                    options={supervisor}
                                                                    isMulti={false}
                                                                    onChange={handleChangeSupervisorFilter}
                                                                    value={supervisor_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_turn && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Turno</label>
                                                                <Select
                                                                    options={turn}
                                                                    isMulti={false}
                                                                    onChange={handleChangeTurnFilter}
                                                                    value={turn_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_establishment &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Establecimiento</label>
                                                                <Select
                                                                    options={establishment}
                                                                    isMulti={false}
                                                                    onChange={handleChangeEstablishmentFilter}
                                                                    value={establishment_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {
                                    permisos.filter(element => element.codigo === "add_note").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="notea">
                                                        Nueva Nota
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimiento</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Supervisor</label>
                                                            <Select
                                                                options={supervisor}
                                                                isMulti={false}
                                                                onChange={handleChangeSupervisor}
                                                                value={supervisor_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Turno</label>
                                                            <Select
                                                                options={turn}
                                                                isMulti={false}
                                                                onChange={handleChangeTurn}
                                                                value={turn_select}
                                                            />
                                                            <br/>
                                                            <Input
                                                                 type="datetime-local"
                                                                name="fecha_nota"
                                                                id="fecha_nota"
                                                                label="Fecha"
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                value={form.fecha_nota}
                                                            />
                                                            <TextArea
                                                                id="comentario"
                                                                name="comentario"
                                                                label="Comentario"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.comentario}
                                                            />
                                                            <br/>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR NOTEA
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"} onChange={handleSearch}/>
                                                                </div>
                                                                { permisos && permisos.filter(x => x.codigo === 'generate_report_notes').length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.secuencial}
                                                                    subtitle={item.establecimiento + ' (' + item.codigo_establecimiento + ')'}
                                                                    rightDescription={'Fecha: ' + item.fecha_nota}
                                                                    bulletType={""}
                                                                    color={item.color}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    <small>Supervisor: {item.supervisor}</small>
                                                                                </div>
                                                                                <div className="mail-items">
                                                                                    <small>Turo: {item.turno}</small>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}

                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.establecimiento  + ' (' + DataSelected.codigo_establecimiento + ')'}
                                                                subtitle={DataSelected.fecha_nota}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.supervisor) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Supervisor: </h6>{DataSelected.supervisor}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.turno) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Turno: </h6>{DataSelected.turno}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_aprobacion) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Fecha de aprobación: </h6>{DataSelected.fecha_aprobacion}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.comentario) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Comentario: </h6>{DataSelected.comentario}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotesAdmin;
